import React, { useEffect, useState, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber } from 'lodash';
import { round } from 'mathjs';

import '../../scss/public.scss';
import './scss/index.scss';
import Color from '@tool/color';
import SubTitle from '../../component/sub-title';
import Tab from '../../component/tab';
import TimeTab from '../../component/time-tab';
import moStaffTrend, { changeType } from './store/index';
import Income from '../../component/income';
import NewIncome from '../../component/new-income';
import CommonTable from '../../component/common-table';
import Empty from '@/component/empty';
import MainTitle from '../../component/main-title';
import moEffectPdf from '../../store/index';
import moMenu from '@/page/effect/store/menu';

interface IProps { }
interface IState { }

const StuffTrend = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    type, adminX, adminY, empty,
    financeX, financeY, techX, techY,
    produceX, produceY, saleX, saleY,
    tableTitle, tableList, overview,
  } = moStaffTrend;

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section id="effect14" className="stuff-trend_10 box-111 human-common-pdf">
      <MainTitle
        title='员工构成时间趋势'
        subtitle={moMenu.industryName}
        bgcolor={Color.primaryColor(0.1)}
        color={Color.primary} />

      <section className="trend-1511">
        {!empty ? (
          <>
            <section className="trend-1515" style={{ width: '50%' }}>
              <section className="trend-6060 trend-6066">
                <p className="line-1011 line-1199"><strong>生产/工程人员</strong></p>
                <Income height={300} xData={produceX} yData={produceY} name="生产/工程人员"
                  bgColor={Color.d9Color(0.05)} />
              </section>
            </section>
            <section className="trend-1515" style={{ width: '50%' }}>
              <section className="trend-6060 trend-6066">
                <p className="line-1011 line-1199" style={{ paddingLeft: '10px' }}>
                  <strong>技术人员占比</strong>
                </p>
                <NewIncome height={300} xData={techX} yData={techY} name="技术人员占比"
                  bgColor={Color.secondaryColor(0.05)} />
              </section>
            </section>
            <section className="trend-1515" style={{ width: '50%' }}>
              <section className="trend-6060 trend-6066">
                <p className="line-1011 line-1199"><strong>销售人员占比</strong></p>
                <Income height={300} xData={saleX} yData={saleY} name="销售人员占比"
                  bgColor={Color.d9Color(0.05)} />
              </section>
            </section>
            <section className="trend-1515" style={{ width: '50%' }}>
              <section className="trend-6060 trend-6066">
                <p className="line-1011 line-1199" style={{ paddingLeft: '10px' }}>
                  <strong>财务人员占比</strong>
                </p>
                <NewIncome height={300} xData={financeX} yData={financeY} name="财务人员占比"
                  bgColor={Color.secondaryColor(0.05)} />
              </section>
            </section>
            <section className="trend-1515" style={{ width: '50%' }}>
              <section className="trend-6060 trend-6066">
                <p className="line-1011 line-1199"><strong>行政人员占比</strong></p>
                <Income height={300} xData={adminX} yData={adminY} name="行政人员占比"
                  bgColor={Color.d9Color(0.05)} />
              </section>
            </section>
            {!isEmpty(overview) ? (
              <section className="chart-detail industry-detail"
                style={{ width: '100%' }}>
                <section>注：</section>
                {
                  overview?.map((res: any, r: any) => {
                    return <section className='item' key={`${r}`}>
                      <b />
                      <p >
                        {res.map((ele: any, e: any) => {
                          return <span className={ele.mark} key={`${e}l`}>
                            {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 1)) : ele.value}
                          </span>;
                        })}
                      </p>
                    </section>;
                  })}
              </section>
            ) : null}
          </>
        ) : (
          <Empty />
        )}
      </section>
    </section>
  );
};

export default observer(StuffTrend);
